import styles from "./styles/preview.module.scss";
import { Box, Typography } from "@mui/material";
import { useUser, useConsole } from "contexts";
import { Button, Flex, IconButton, Image, Modal } from "ui";
import PropTypes from "prop-types";

const StoryPreview = ({ open, handleClose, handleRead, ...story }) => {
  const { uid } = useUser();

  return (
    <Modal className={styles.root} open={open} onClose={handleClose}>
      <Image
        alt={story.name}
        height={225}
        src={story.covers?.landscape}
        width={400}
      />
      <Box className={styles.gradient} />
      <Box className={styles.close}>
        <IconButton
          color="action"
          icon="close"
          onClick={handleClose}
          size="medium"
        />
      </Box>
      <Box className={styles.title}>
        <Typography variant="h6" component="h2">
          {story.name} <strong>{story.year}</strong>
        </Typography>
      </Box>
      <Box className={styles.actions}>
        <Button
          color="white"
          className={styles.mainButton}
          disabled={!story.file && story.builtWith !== "images"}
          onClick={handleRead}
          size="large"
          startIcon="auto_stories"
        >
          Leer
        </Button>
        <Flex hidden={!uid} spacing={{ xs: 1.5, sm: 0.75 }}>
          {[OrderButton, FavoriteButton, ShareButton].map(
            (Component, index) => (
              <Component key={index} onClose={handleClose} story={story} />
            )
          )}
          <MoreButton onClose={handleClose} story={story} />
        </Flex>
      </Box>
      <Box className={styles.preview}>
        <Typography variant="h6" component="h2">
          {story.name} <strong>{story.year}</strong>
        </Typography>
        <Typography variant="body1">{story.summary}</Typography>
      </Box>
    </Modal>
  );
};

export const ToggleButton = ({ icon, label, ...props }) => {
  const { screen } = useConsole();

  return (
    <Box className={styles.toggle}>
      <IconButton
        {...props}
        color={!screen.isMobile ? "action" : "inherit"}
        icon={icon}
        variant="outlined"
      />
      <span>{label}</span>
    </Box>
  );
};

import FavoriteButton from "./actions/FavoriteButton";
import MoreButton from "./actions/MoreButton";
import OrderButton from "./actions/OrderButton";
import ShareButton from "./actions/ShareButton";

StoryPreview.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleRead: PropTypes.func.isRequired,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    year: PropTypes.string,
    description: PropTypes.string,
    covers: PropTypes.shape({
      landscape: PropTypes.string,
    }),
    file: PropTypes.string,
    builtWith: PropTypes.string,
    isOwner: PropTypes.bool,
    isPublic: PropTypes.bool,
  }).isRequired,
};

export default StoryPreview;
